.frame {
  position: absolute;
  top: 0;
  left: 0;
  transform-origin: 0 0;
  outline: 1.5px solid var(--focus);
  outline-offset: 1px;
  pointer-events: none;
  z-index: 2147483000;
}

.handle {
  position: absolute;
  width: 10px;
  height: 10px;
  margin: -5px;
  background: var(--surface);
  border: 1.5px solid var(--focus);
  border-radius: 2px;
  pointer-events: auto;
  touch-action: none;
}

.handle[data-handle='n'] {
  top: 0;
  left: 50%;
  cursor: ns-resize;
}
.handle[data-handle='s'] {
  top: 100%;
  left: 50%;
  cursor: ns-resize;
}
.handle[data-handle='e'] {
  top: 50%;
  left: 100%;
  cursor: ew-resize;
}
.handle[data-handle='w'] {
  top: 50%;
  left: 0;
  cursor: ew-resize;
}
.handle[data-handle='ne'] {
  top: 0;
  left: 100%;
  cursor: nesw-resize;
}
.handle[data-handle='sw'] {
  top: 100%;
  left: 0;
  cursor: nesw-resize;
}
.handle[data-handle='nw'] {
  top: 0;
  left: 0;
  cursor: nwse-resize;
}
.handle[data-handle='se'] {
  top: 100%;
  left: 100%;
  cursor: nwse-resize;
}

.rotateStem {
  position: absolute;
  left: 50%;
  top: -22px;
  width: 1px;
  height: 20px;
  background: var(--focus);
}

.rotate {
  position: absolute;
  left: 50%;
  top: -30px;
  width: 14px;
  height: 14px;
  margin-left: -7px;
  border-radius: 50%;
  background: var(--surface);
  border: 1.5px solid var(--focus);
  pointer-events: auto;
  cursor: grab;
  touch-action: none;
}

@media (pointer: coarse) {
  .handle {
    width: 18px;
    height: 18px;
    margin: -9px;
  }
  .rotate {
    width: 24px;
    height: 24px;
    margin-left: -12px;
    top: -40px;
  }
}

.connectionFrame {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  overflow: visible;
  pointer-events: none;
  z-index: 2147483000;
}
